import Template from "./Container"

export default Template
